export interface FileUploadResponse {
  file: {
    downloadURL: string;
    uploadedBy: string;
    originalFileName: string;
    contentType: string;
    id: number;
    uploadedOn: Date;
    fileName: string;
  },
}
